import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Select from 'components/UI/Input/Select';
import InputLabel from 'components/UI/Input/InputLabel';

function EditableSelect({
    containerClassName,
    disableLabel,
    editing,
    inputProps,
    labelContainerClassName,
    labelText,
    labelProps,
    selectContainerClassName,
    customClasses,
    isMulti,
    formatCreateLabel,
})
{
    const containerClasses = clsx({
        'tw-flex tw-flex-row': !customClasses,
        [containerClassName]: !!containerClassName,

    });

    const labelContainerClasses = clsx({
        'tw-flex tw-flex-1': !customClasses,
        [labelContainerClassName]: !!labelContainerClassName,
    });

    const selectContainerClasses = clsx({
        'tw-flex tw-flex-1 tw-mt-1': !customClasses,
        [selectContainerClassName]: !!selectContainerClassName,
    });

    return (
        editing ? (
            <div className={containerClasses}>
                { !disableLabel
                    && (
                        <div className={labelContainerClasses}>
                            <label className={`tw-flex tw-font-bold tw-mr-1 ${labelProps.className}`}>{labelText}</label>
                        </div>
                    )}
                <div className={selectContainerClasses}>

                    <Select
                        async={inputProps.async}
                        creatable={inputProps.creatable}
                        containerClassName={inputProps.containerClassName}
                        error={inputProps.error}
                        errorClassName={inputProps.errorClassName}
                        onChange={inputProps.onChange}
                        path={inputProps.path}
                        printErrors={inputProps.printErrors}
                        readOnly={inputProps.readOnly}
                        type={inputProps.type}
                        value={inputProps.value}
                        options={inputProps.options}
                        disabled={inputProps.disabled}
                        placeholder={inputProps.placeholder}
                        styles={inputProps.styles}
                        loadOptions={inputProps.loadOptions}
                        defaultValue={inputProps.defaultValue}
                        clearAfterChange={inputProps.clearAfterChange}
                        isMulti={isMulti}
                        formatCreateLabel={formatCreateLabel}
                    />
                </div>
            </div>
        ) : (
            <div className={`${containerClasses} tw-py-1.5 tw-rounded tw-px-3 tw-border tw-bg-gray-50 dark:tw-bg-neutral-600 dark:tw-border-gray-400 hover:tw-border-primary-default`}>
                <InputLabel label={labelText} text={inputProps.getOptionLabel ? inputProps.getOptionLabel(inputProps.value) : ' '} />
            </div>
        )
    );
}

EditableSelect.defaultProps = {
    containerClassName: '',
    disableLabel: false,
    customClasses: false,
    inputProps: {},
    labelProps: {
        className: 'tw-text-sm',
        clearAfterChange: false,
    },
    isMulti: false,
    formatCreateLabel: 'Create ',
};

EditableSelect.propTypes = {
    containerClassName: PropTypes.string,
    disableLabel: PropTypes.bool,
    customClasses: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    inputProps: PropTypes.shape({
        getOptionLabel: PropTypes.func,
        getOptionValue: PropTypes.func,
        async: PropTypes.bool,
        creatable: PropTypes.bool,
        styles: PropTypes.object,
        containerClassName: PropTypes.string,
        error: PropTypes.node,
        errorClassName: PropTypes.string,
        clearAfterChange: PropTypes.bool,
        onChange: PropTypes.func,
        path: PropTypes.string,
        printErrors: PropTypes.bool,
        readOnly: PropTypes.bool,
        type: PropTypes.string,
        value: PropTypes.any,
        defaultValue: PropTypes.any,
        options: PropTypes.array,
        disabled: PropTypes.bool,
        placeholder: PropTypes.string,
        loadOptions: PropTypes.func,
    }),
    labelContainerClassName: PropTypes.string,
    labelText: PropTypes.node.isRequired,
    labelProps: PropTypes.shape({
        className: PropTypes.string.isRequired,
    }),
    selectContainerClassName: PropTypes.string,
    isMulti: PropTypes.bool,
    formatCreateLabel: PropTypes.string,
};

export default EditableSelect;
